import React, { useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, BarChart3, LogOut, ExternalLink, IndianRupee } from 'lucide-react';
import { useAdminAuth } from '../contexts/AdminAuthContext';

const AdminLayout = () => {
  const { user, checking, logout } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'O2 Control Panel';
    const m = document.createElement('meta');
    m.name = 'robots';
    m.content = 'noindex, nofollow';
    document.head.appendChild(m);
    return () => { try { document.head.removeChild(m); } catch {} };
  }, []);

  useEffect(() => {
    if (!checking && !user) navigate('/o2-control-panel', { replace: true });
  }, [user, checking, navigate]);

  if (checking) {
    return <div className="admin-loading">Loading…</div>;
  }
  if (!user) return null;

  const handleLogout = async () => {
    await logout();
    navigate('/o2-control-panel', { replace: true });
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <span className="admin-brand-mark">O2</span>
          <div>
            <div className="admin-brand-title">Control Panel</div>
            <div className="admin-brand-sub">{user.role === 'owner' ? 'Owner' : 'Store Manager'}</div>
          </div>
        </div>

        <nav className="admin-nav">
          <NavLink to="/o2-control-panel/dashboard" className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`} data-testid="nav-dashboard">
            <LayoutDashboard size={18} /> Dashboard
          </NavLink>
          <NavLink to="/o2-control-panel/leads" className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`} data-testid="nav-leads">
            <Users size={18} /> Leads
          </NavLink>
          <NavLink to="/o2-control-panel/sales" className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`} data-testid="nav-sales">
            <IndianRupee size={18} /> Sales Report
          </NavLink>
          <NavLink to="/o2-control-panel/reports" className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`} data-testid="nav-reports">
            <BarChart3 size={18} /> Reports
          </NavLink>
          <a
            href="https://analytics.google.com/analytics/web/"
            target="_blank"
            rel="noopener noreferrer"
            className="admin-nav-link admin-nav-link-ext"
            data-testid="nav-ga4"
          >
            <ExternalLink size={16} /> View Visitors in GA4
          </a>
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-email" title={user.email}>{user.email}</div>
          <button onClick={handleLogout} className="admin-logout-btn" data-testid="admin-logout">
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
